import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getCurtainTrack } from '../../../helpers/getCurtainTrack';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  option: string,
  pleatType: string,
  fitting: string,
  context: ProductBuilderMachineContext,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (option, pleatType, fitting, context, send) => () => {
//   const curtainTrack = getCurtainTrack(option, pleatType, fitting, context);

//   const track = `${option}:${curtainTrack.id}`;
//   const trackPrice = curtainTrack.price;
    const pullRod = `${option}`;
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
    //   track,
    //   trackPrice,
    pullRod
    },
  });
};

export const PullRod = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const pullRodTypes = baseProduct ? baseProduct.metafields.pull_rod || [] : [];
  const {
    custom: { pullRod, pleatType, fitting },
  } = state.context;
  const productType = getBaseProductType(state.context);

  if (!Array.isArray(pullRodTypes) || pullRodTypes.length === 0) {
    if (isCurrentState('track', state)) {
      throwError(state);
    }
  }

  return (
    <SectionContent>
      <Heading>Pull rod</Heading>
      <Selector isSlider={true}>
        {pullRodTypes.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'pullRod',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={
                option ===
                (typeof pullRod !== 'undefined' ? pullRod.split(':')[0] : '')
              }
              onClick={onClick(option, pleatType, fitting, state.context, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
